import api from "../api";

import schemas from "./schemas";

const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

class MasterData {
  apiUri = API_MODE === 'LOCAL' ? "/data" : api.apiUri;
  apiSuffix = API_MODE === 'LOCAL' ? ".json" : '/';
  requests = {};

  constructor() {
    this.asyncKeys = [];
    for (const id of Object.keys(schemas)) {
      const schema = schemas[id];
      if (schema.data) {
        // 同期データ
        this[id] = schema.data;
      } else {
        // 非同期データ
        this["prepare" + capitalize(id)] = () => {
          return this.prepare(id);
        };
        this["prepared" + capitalize(id)] = () => {
          return this.prepared(id);
        };
        this.asyncKeys.push(id);
      }
    }
  }
  // 非同期データを全て取得する
  prepareAll() {
    return this.prepare(this.asyncKeys);
  }
  // 非同期データがすべて解決されているかを知る
  preparedAll() {
    return this.prepared(this.asyncKeys);
  }

  // 一度だけリクエストを行い、以降はそのリクエストを使い回す。
  // 特定へのパスへのmasterデータ取得を抽象化する
  loadJson(path) {
    if (!this.requests[path]) {
      this.requests[path] = (async () => {
        const response = await fetch(`${this.apiUri}${path}${this.apiSuffix}`, {credentials: "same-origin"});
        return response.ok ? response.json() : {};
      })();
    }
    return this.requests[path];
  }
  // 与えられたschemaIdに基づいて、データの準備を行う
  // 事前に、injectsで示されたデータの解決を行う。
  // 循環参照のチェックは行わないので注意（無限ループになる）
  // 複数のschemaIdを配列で渡すと全て解決する。
  // 関数を渡すと、injectsフィールドを参照して、その関数が利用するデータを解決する。
  async prepare(id) {
    // 配列を渡すとすべて解決する
    if (Array.isArray(id)) {
      return Promise.all(id.map(_id => this.prepare(_id)));
    }
    // 関数を渡すと、injectsフィールドを参照して解決する
    if (typeof id === "function") {
      return this.prepare(id.injects);
    }
    const { path, handler, injects } = schemas[id];
    if (!this[id]) {
      // スキーマが他のリソースを要求する場合は、事前に解決する（データ取得は非同期）
      const injectsPromise = injects && this.prepare(injects);
      const data = await this.loadJson(path);
      await injectsPromise;
      this[id] = handler(data, this);
    }
    return this[id];
  }
  // schemaIdが準備されているかを、同期的に返す
  prepared(id) {
    if (Array.isArray(id)) {
      return id.every(key => this[key]);
    } else {
      return Boolean(this[id]);
    }
  }
}
const masterData = new MasterData();
window.masterData = masterData;
export default masterData;



// WEBPACK FOOTER //
// ./lib/masterData/index.js